import { useCalendarStore } from '@/store/calendarStore';
import { getMonthName, getDaysInMonth, getStartOfMonth, isSameDayAs, parseDateFromBackend } from '@/utils/dateUtils';
import clsx from 'clsx';

/**
 * Vista de año del calendario
 */
export default function YearView() {
  const { currentDate, setCurrentDate, citas, lecturas, eventos } = useCalendarStore();

  const year = currentDate.getFullYear();
  const months = Array.from({ length: 12 }, (_, i) => new Date(year, i, 1));

  const getItemsForDay = (day) => {
    const citasCount = citas.filter(c => isSameDayAs(parseDateFromBackend(c.fechaInicio), day)).length;
    const lecturasCount = lecturas.filter(l => isSameDayAs(parseDateFromBackend(l.fecha), day)).length;
    const eventosCount = eventos.filter(e => isSameDayAs(parseDateFromBackend(e.fechaInicio), day)).length;
    return citasCount + lecturasCount + eventosCount;
  };

  const handleDayClick = (day) => {
    setCurrentDate(day);
  };

  const MiniMonth = ({ month }) => {
    const days = getDaysInMonth(month);
    const startOfMonth = getStartOfMonth(month);
    const firstDayOfWeek = startOfMonth.getDay();
    const today = new Date();

    return (
      <div className="bg-white rounded-lg p-3 border border-gray-200">
        <h4 className="font-semibold text-center mb-2 text-sm">
          {getMonthName(month)}
        </h4>
        <div className="grid grid-cols-7 gap-1">
          {/* Días de la semana */}
          {['D', 'L', 'M', 'M', 'J', 'V', 'S'].map((d, idx) => (
            <div key={idx} className="text-center text-xs text-gray-500 font-medium">
              {d}
            </div>
          ))}
          
          {/* Espacios vacíos */}
          {Array.from({ length: firstDayOfWeek }).map((_, idx) => (
            <div key={`empty-${idx}`} className="aspect-square"></div>
          ))}
          
          {/* Días */}
          {days.map((day, idx) => {
            const isToday = isSameDayAs(day, today);
            const hasItems = getItemsForDay(day) > 0;
            
            return (
              <button
                key={idx}
                onClick={() => handleDayClick(day)}
                className={clsx(
                  'aspect-square text-xs rounded hover:bg-gray-100 transition-colors',
                  {
                    'bg-accent text-white font-bold': isToday,
                    'font-semibold': hasItems && !isToday,
                    'text-gray-400': !hasItems && !isToday,
                  }
                )}
              >
                <div className="relative">
                  {day.getDate()}
                  {hasItems && !isToday && (
                    <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-1 h-1 bg-primary rounded-full"></div>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <div className="bg-gray-50 rounded-lg p-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {months.map((month, idx) => (
          <MiniMonth key={idx} month={month} />
        ))}
      </div>
      
      <div className="mt-6 text-center text-sm text-gray-600">
        <p>Haz clic en cualquier día para ver sus detalles</p>
      </div>
    </div>
  );
}



